export default {
      id: "unit_dashboard__massage-usage",
      viewBox: "0 0 39 37",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__massage",
      toString: function () {
        return this.url;
      }
    }